import { render, staticRenderFns } from "./Correspondence.vue?vue&type=template&id=921e42f4&scoped=true"
import script from "./Correspondence.vue?vue&type=script&lang=js"
export * from "./Correspondence.vue?vue&type=script&lang=js"
import style0 from "./Correspondence.vue?vue&type=style&index=0&id=921e42f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921e42f4",
  null
  
)

export default component.exports